import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AssetHealthState {
  status: string;
  assetId?: string;
  lastUpdated: string;
}

interface SetAssetHealthPayload {
  status: string;
  assetId?: string;
}

const initialState: AssetHealthState = {
  status: 'Healthy',
  lastUpdated: new Date().toISOString(),
};

const assetHealthSlice = createSlice({
  name: 'assetHealth',
  initialState,
  reducers: {
    setAssetHealthStatus: (
      state,
      action: PayloadAction<SetAssetHealthPayload>
    ) => {
      state.status = action.payload.status;
      state.assetId = action.payload.assetId;
      state.lastUpdated = new Date().toISOString();
    },
  },
});

export const { setAssetHealthStatus } = assetHealthSlice.actions;
export default assetHealthSlice.reducer;
